module.exports = __webpack_public_path__ + "img/banner-shoppings-2.c43bfb4c.jpg";